let cookiePopup = document.getElementById('cookie-banner');

// $cookie = getCookie('cookie-policy');

window.addEventListener('load', checkCookie());


let button = cookiePopup.getElementsByTagName('button');

button[0].addEventListener('click', function() {
    setCookie("cookie-policy", 'accepted', 365);
    cookiePopup.classList.remove('open');
    cookiePopup.remove();
})

function checkCookie() {
    let cookie = getCookie('cookie-policy');

    if (cookie == '') {
        cookiePopup.classList.add('open');
    } else {
        cookiePopup.remove();
    }
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
